import React from 'react';
import ProductCardGrid from './ProductCardGrid';
import {connectToStore} from './Provider';
import createTaxonomyLink from '../utils/createTaxonomyLink';
import { Link } from 'gatsby';

const ProductCatalogueGrid = ({
	title,
	subtitle,
	products,
	shopAllLink,
	shopCollectionLink,
	openVideoModal,
	openQuickAddProduct,
}) => {
	let collectionLink;
	let shopAllLinkButton;

	if (shopCollectionLink._type === 'link') {
		if (shopCollectionLink.url[0] === '/') {
			collectionLink = (
				<Link
					className="full-width button--secondary"
					title={shopCollectionLink.title}
					to={shopCollectionLink.url}>
					{shopCollectionLink.title}
				</Link>
			);
		} else {
			collectionLink = (
				<a
					className="full-width button--secondary"
					title={shopCollectionLink.title}
					href={shopCollectionLink.url}>
					{shopCollectionLink.title}
				</a>
			);

		}
	} else if (shopCollectionLink._type === 'videoModalLink') {
		collectionLink = (
			<button
				title={shopCollectionLink.title}
				className="full-width button--secondary"
				onClick={() => openVideoModal(shopCollectionLink.videoId)}
				name="video">
				{shopCollectionLink.title}
			</button>
		);
	} else if (shopCollectionLink._type === 'taxonomyLink') {
		collectionLink = (
			<Link
				className="full-width button--secondary"
				title={shopCollectionLink.title}
				to={createTaxonomyLink(shopCollectionLink.taxonomies)}>
				{shopCollectionLink.title}
			</Link>
		);
	}

	if (shopAllLink._type === 'link') {
		if (shopAllLink.url[0] === '/') {
			shopAllLinkButton = (
				<Link
					className="full-width button--secondary"
					title={shopAllLink.title}
					to={shopAllLink.url}>
					{shopAllLink.title}
				</Link>
			);
		} else {
			shopAllLinkButton = (
				<a
					className="full-width button--secondary"
					title={shopAllLink.title}
					href={shopAllLink.url}>
					{shopAllLink.title}
				</a>
			);
		}
	} else if (shopAllLink._type === 'videoModalLink') {
		shopAllLinkButton = (
			<button
				title={shopAllLink.title}
				className="full-width button--secondary"
				onClick={() => openVideoModal(shopAllLink.videoId)}
				name="video">
				{shopAllLink.title}
			</button>
		);
	} else if (shopAllLink._type === 'taxonomyLink') {
		shopAllLinkButton = (
			<Link
				className="full-width button--secondary"
				title={shopAllLink.title}
				to={createTaxonomyLink(shopAllLink.taxonomies)}>
				{shopAllLink.title}
			</Link>
		);
	}

	const productColumns = products.map((product, index) => (
		<div
			className="col c6--sm c4--md mb4 mb5--md"
			key={`${index}_${product._id}`}>
			<ProductCardGrid
				title={product.title}
				slug={product.slug}
				mainImage={product.mainImage}
				brand={product.brand}
				cents={product.cents}
				compareAtCents={product.compareAtCents}
				onClickQuickAdd={() => openQuickAddProduct(product)}
				largePrice
				noBackground
			/>
		</div>
	));
	
	return (
		<div className="grid-container contained mt12 mb12">
			<div className="row align--bottom mb4 mb8--md">
				<div className="col c8--md">
					<h3 className="tc tl--md uppercase fw--600 mb1 mb2--md">
						{subtitle}
					</h3>
					<h2 className="tc tl--md domaine--large">
						{title}
					</h2>
				</div>
				<div className="col c4 show--md">
					<ul className="list list--horizontal gutter--none tr">
						<li className="list__item">
							{collectionLink}
						</li>
					</ul>
				</div>
			</div>

			<div className="row mb1 mb3--md">
				{productColumns}
			</div>

			<div className="row align--center gutter--mobile">
				<div className="col c6--md c3--xl mb2 mb0--md">
					{collectionLink}
				</div>
				<div className="col c6--md c3--xl">
					{shopAllLinkButton}
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = () => ({});

const mapStoreToProps = ({
	openQuickAddProduct,
	openVideoModal,
}) => ({
	openQuickAddProduct,
	openVideoModal,
});

export default connectToStore(mapStateToProps, mapStoreToProps)(ProductCatalogueGrid);